function sumInputs(inputs) {
  return inputs.reduce((acc, value) => {
    return value ? acc + parseFloat(value) : acc;
  }, 0)
}

function returnHomeDepositCalculatorOutput(inputs) {
  const governmentCharges = sumInputs([inputs.stampDuty, inputs.mortgageRegistration, inputs.transferFee]);
  const loanDeposit = inputs.loanDeposit;
  const loanFees = sumInputs([inputs.loanApplicationFee, inputs.loanEstablishmentFee, inputs.lendersMortgageInsurance])
  const otherCosts = sumInputs([inputs.conveyancingFees, inputs.buildingPestInspection, inputs.homeInsurance, inputs.movingExpenses, inputs.other])
  const totalPropertyBuyingCosts = sumInputs([governmentCharges, loanDeposit, loanFees, otherCosts])
  return {
    governmentCharges,
    loanDeposit,
    loanFees,
    otherCosts,
    totalPropertyBuyingCosts
  }
}

export default returnHomeDepositCalculatorOutput
